export enum ClaraForPlannersEscalationAction {
  BOOK = 'book',
  COMPARE = 'compare'
}
